export class ExamEvaluationConfigurationDTO{
    constructor(
        public etiqueta : string,
        public tipo : string,
        public orden : string,
        public longitud : string,
        public comentario : string,
        public isSelected: boolean = false,
        public isVisible: boolean,
        public listToSelect : ExamEvaluationConfigurationDTO[]= [],
    ){}
}

export class ExamEvaluation{
    constructor(
        public elementosValoracion : ExamItemEvaluation[][] = [],
        public respuestasExtendias: ExamItemEvaluation[] = [],        
    ){}
}

export class ExamItemEvaluation{
    constructor(
        public value : string,
        public readOnly: boolean = false,
        public error: boolean = false
    ){}
}

export class ExamEvaluationValidationResponse{
    constructor(
        public status: boolean,        
        public message: string = ''

    ){}
}

